import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { Navbar } from 'reactstrap';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { loginSelector } from '../redux/auth';
import NavbarComponent from './components/navbar';
import SidebarComponent from './components/sidebar';

const NAV_ITEMS = [
  { title: 'Home', path: '/' },
  { title: 'Nūn Editor', path: '/editor' },
  { title: 'History', path: '/history' }
];

const NAV_ITEMS_ADMIN = [
  { title: 'Admin Dashboard', path: '/admin' },
];
const BREAK_POINT = 768;

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [menuVisibility, setMenuVisibility] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const { data } = useSelector(loginSelector);

  // Memoize derived values
  const isMobile = useMemo(() => windowWidth < BREAK_POINT, [windowWidth]);
  const isAuth = useMemo(() => !!data.access_token, [data.access_token]);
  const isAdmin = useMemo(() => data.user_role === 'admin', [data.user_role]);
  const navItems = useMemo(() => isAdmin ? NAV_ITEMS_ADMIN : NAV_ITEMS, [isAdmin]);

  // Close menu when location changes (on mobile)
  useEffect(() => {
    if (menuVisibility && isMobile) {
      setMenuVisibility(false);
    }
  }, [location, menuVisibility, isMobile]);

  // Fix resize listener with proper cleanup
  useEffect(() => {
    const handleWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowWidth);

    // Cleanup function
    return () => {
      window.removeEventListener('resize', handleWindowWidth);
    };
  }, []); // No dependencies - only runs on mount and unmount

  // Auth navigation logic
  useEffect(() => {
    if (!isAuth) {
      navigate('/login');
      return;
    }

    // Only redirect admin from root path to admin
    if (isAdmin && location.pathname === '/') {
      navigate('/admin');
    }
  }, [isAuth, isAdmin]); // Remove location.pathname and navigate from dependencies

  return (
    <div
      className={classnames(
        'wrapper navbar-floating footer-static horizontal-layout horizontal-menu vertical-overlay-menu',
        {
          'menu-hide': !menuVisibility,
          'menu-open': menuVisibility
        }
      )}>
      {isMobile && (
        <SidebarComponent
          menuVisibility={menuVisibility}
          setMenuVisibility={setMenuVisibility}
          items={navItems}
        />
      )}

      <Navbar
        expand="lg"
        container={false}
        className="header-navbar navbar-fixed align-items-center navbar-shadow navbar-brand-center">
        <div className="navbar-container d-flex content">
          <NavbarComponent
            items={navItems}
            setMenuVisibility={setMenuVisibility}
          />
        </div>
      </Navbar>

      <div className="app-content content overflow-hidden">
        <div className="container-xxl p-0">
          <Outlet />
        </div>
      </div>

      <div
        className={classnames('sidenav-overlay', {
          show: menuVisibility
        })}
        onClick={() => setMenuVisibility(false)}></div>
      <footer></footer>
    </div>
  );
};

export default React.memo(MainLayout); // Memoize the entire component
